export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage35.5dce3454.png";